/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PhoneNo.vue?vue&type=template&id=36c39a68&"
import script from "./PhoneNo.vue?vue&type=script&lang=js&"
export * from "./PhoneNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports